import { render } from "./DeleteContact.vue?vue&type=template&id=662142e0"
import script from "./DeleteContact.vue?vue&type=script&lang=js"
export * from "./DeleteContact.vue?vue&type=script&lang=js"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__